import { B as Button, d as defineCustomElement$1 } from './button.js';

const TtButton = Button;
const defineCustomElement = defineCustomElement$1;

export { TtButton, defineCustomElement };
